export const Divide = (): JSX.Element => <hr className='bg-gray-300' />;
